import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function WhyFailSection() {
  return <section className="py-20 px-4 md:px-8 bg-cream" data-id="element-306">
      <div className="max-w-5xl mx-auto" data-id="element-307">
        <div className="text-center mb-16" data-id="element-308">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brown-deep mb-4" data-id="element-309">
            ¿Por qué fallan las fajas comunes?
          </h2>
          <p className="text-xl text-coral font-medium italic" data-id="element-310">
            El famoso "Efecto Tapón"
          </p>
          <p className="mt-6 max-w-2xl mx-auto text-brown-medium" data-id="element-311">
            Las fajas convencionales de baja calidad cortan la circulación y
            generan más inflamación. En lugar de ayudar, bloquean tu sistema
            linfático.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-stretch" data-id="element-312">
          {/* Left Column: The Problem */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-gray-50 p-8 rounded-2xl border border-gray-200 relative overflow-hidden" data-id="element-313">
            <div className="absolute top-0 left-0 w-full h-1 bg-gray-300" data-id="element-314"></div>
            <div className="flex items-center gap-3 mb-6" data-id="element-315">
              <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-500" data-id="element-316">
                <X className="w-5 h-5" data-id="element-317" />
              </div>
              <h3 className="text-xl font-bold text-gray-600" data-id="element-318">Faja Común</h3>
            </div>
            <ul className="space-y-4" data-id="element-319">
              {['Se enrolla constantemente', 'Irrita la piel con el roce', 'Solo aprieta, no drena', 'Material barato que no dura'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-600" data-id="element-320">
                  <X className="w-5 h-5 text-gray-400 mt-0.5 flex-shrink-0" data-id="element-321" />
                  <span data-id="element-322">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Column: The Solution */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl border-2 border-gold/30 shadow-xl relative overflow-hidden" data-id="element-323">
            <div className="absolute top-0 left-0 w-full h-1 bg-gold" data-id="element-324"></div>
            <div className="flex items-center gap-3 mb-6" data-id="element-325">
              <div className="w-8 h-8 rounded-full bg-sage/20 flex items-center justify-center text-sage" data-id="element-326">
                <Check className="w-5 h-5" data-id="element-327" />
              </div>
              <h3 className="text-xl font-bold text-brown-deep" data-id="element-328">
                Kit Vientre Plano 21D
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-329">
              {['Material reforzado anti-enrollado', 'Suave al contacto con la piel', 'Calor + drenaje + protocolo', 'Calidad profesional duradera'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brown-deep font-medium" data-id="element-330">
                  <Check className="w-5 h-5 text-sage mt-0.5 flex-shrink-0" data-id="element-331" />
                  <span data-id="element-332">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}